<script lang="ts">
	import toolRoomBannerSm from "../assets/images/tool-room-banner.png?webp&w=640&imagetools";
	import toolRoomBannerMd from "../assets/images/tool-room-banner.png?webp&w=768&imagetools";
	import toolRoomBannerLg from "../assets/images/tool-room-banner.png?webp&w=1324&imagetools";
	import toolRoomBannerXl from "../assets/images/tool-room-banner.png?webp&w=1759&imagetools";
	import foundryBannerSm from "../assets/images/foundry-banner.png?webp&w=640&imagetools";
	import foundryBannerMd from "../assets/images/foundry-banner.png?webp&w=768&imagetools";
	import foundryBannerLg from "../assets/images/foundry-banner.png?webp&w=1324&imagetools";
	import foundryBannerXl from "../assets/images/foundry-banner.png?webp&w=1759&imagetools";
	import bendingBannerSm from "../assets/images/bedning-banner.png?webp&w=640&imagetools";
	import bendingBannerMd from "../assets/images/bedning-banner.png?webp&w=768&imagetools";
	import bendingBannerLg from "../assets/images/bedning-banner.png?webp&w=1324&imagetools";
	import bendingBannerXl from "../assets/images/bedning-banner.png?webp&w=1759&imagetools";
	import machiningBannerSm from "../assets/images/machining-banner.png?webp&w=640&imagetools";
	import machiningBannerMd from "../assets/images/machining-banner.png?webp&w=768&imagetools";
	import machiningBannerLg from "../assets/images/machining-banner.png?webp&w=1324&imagetools";
	import machiningBannerXl from "../assets/images/machining-banner.png?webp&w=1759&imagetools";
	import laseringBannerSm from "../assets/images/lasering-banner.png?webp&w=640&imagetools";
	import laseringBannerMd from "../assets/images/lasering-banner.png?webp&w=768&imagetools";
	import laseringBannerLg from "../assets/images/lasering-banner.png?webp&w=1324&imagetools";
	import laseringBannerXl from "../assets/images/lasering-banner.png?webp&w=1759&imagetools";
	import weldingBannerSm from "../assets/images/welding-banner.png?webp&w=640&imagetools";
	import weldingBannerMd from "../assets/images/welding-banner.png?webp&w=768&imagetools";
	import weldingBannerLg from "../assets/images/welding-banner.png?webp&w=1324&imagetools";
	import weldingBannerXl from "../assets/images/welding-banner.png?webp&w=1759&imagetools";
	import heatTreatmentBannerSm from "../assets/images/heat-treatment-banner.png?webp&w=640&imagetools";
	import heatTreatmentBannerMd from "../assets/images/heat-treatment-banner.png?webp&w=768&imagetools";
	import heatTreatmentBannerLg from "../assets/images/heat-treatment-banner.png?webp&w=1324&imagetools";
	import heatTreatmentBannerXl from "../assets/images/heat-treatment-banner.png?webp&w=1759&imagetools";
	import plasticsBannerSm from "../assets/images/production-of-plastic-banner.png?webp&w=640&imagetools";
	import plasticsBannerMd from "../assets/images/production-of-plastic-banner.png?webp&w=768&imagetools";
	import plasticsBannerLg from "../assets/images/production-of-plastic-banner.png?webp&w=1324&imagetools";
	import plasticsBannerXl from "../assets/images/production-of-plastic-banner.png?webp&w=1759&imagetools";
	import productionBannerSm from "../assets/images/production-banner.png?webp&w=640&imagetools";
	import productionBannerMd from "../assets/images/production-banner.png?webp&w=768&imagetools";
	import productionBannerLg from "../assets/images/production-banner.png?webp&w=1324&imagetools";
	import productionBannerXl from "../assets/images/production-banner.png?webp&w=1759&imagetools";
	import Banner from "./Banner.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./TechnologyBanners.translations.json";
	import { nbspify } from "../../../core/utils/nbspify.js";

	const translate = getTranslate(translations, true);
	const pointsTechnology = translate("toolRoomPoints").split("\n");
	const pointsFoundry = translate("foundryPoints").split("\n");
	const pointsBending = translate("bendingPoints1").split("\n");
	const pointsMachining = translate("machiningPoints").split("\n");
	const pointsWelding = translate("weldingPoints").split("\n");
	const laseringPerex = translate("laseringPerex").split("\n");
	const heatTreatmentPerex = translate("heatTreatmentPerex").split("\n");
	const plasticsPerex = translate("plasticsPerex2").split("\n");

	/* eslint-disable svelte/no-at-html-tags */
</script>

<Banner
	id="toolRoom"
	title={translate("toolRoom")}
	image={toolRoomBannerXl}
	imageSourcesets={{
		"<sm": toolRoomBannerSm,
		"<md": toolRoomBannerMd,
		"<lg": toolRoomBannerLg,
		"<xl": toolRoomBannerXl,
	}}
	shrink="toBottom"
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20 max-lg:pt-20"
>
	<div slot="content">
		<p class="text-base font-light min-[425px]:text-[1.125rem]">{translate("toolRoomPerex")}</p>
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each pointsTechnology as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
	</div>
</Banner>
<Banner
	id="foundry"
	title={translate("foundry")}
	textBlockPosition="right"
	image={foundryBannerXl}
	imageSourcesets={{
		"<sm": foundryBannerSm,
		"<md": foundryBannerMd,
		"<lg": foundryBannerLg,
		"<xl": foundryBannerXl,
	}}
	shrink="toBottom"
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<p class="text-base font-light min-[425px]:text-[1.125rem]">{translate("foundryPerex")}</p>
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each pointsFoundry as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
	</div>
</Banner>
<Banner
	id="bending"
	title={translate("bending")}
	shrink="toBottom"
	image={bendingBannerXl}
	imageSourcesets={{
		"<sm": bendingBannerSm,
		"<md": bendingBannerMd,
		"<lg": bendingBannerLg,
		"<xl": bendingBannerXl,
	}}
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<p class="mb-1 text-base font-light min-[425px]:text-[1.125rem]">{translate("bending1")}</p>
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each pointsBending as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
		<div class="mt-5">
			<p class="mb-1 text-base font-light min-[425px]:text-[1.125rem]">{translate("bending2")}</p>
			<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
				<li>{translate("bendingPoints2")}</li>
			</ul>
		</div>
	</div>
</Banner>
<Banner
	id="machining"
	title={translate("machining")}
	shrink="toBottom"
	textBlockPosition="right"
	image={machiningBannerXl}
	imageSourcesets={{
		"<sm": machiningBannerSm,
		"<md": machiningBannerMd,
		"<lg": machiningBannerLg,
		"<xl": machiningBannerXl,
	}}
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each pointsMachining as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
	</div>
</Banner>
<Banner
	id="lasering"
	title={translate("lasering")}
	shrink="toBottom"
	image={laseringBannerXl}
	imageSourcesets={{
		"<sm": laseringBannerSm,
		"<md": laseringBannerMd,
		"<lg": laseringBannerLg,
		"<xl": laseringBannerXl,
	}}
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each laseringPerex as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
	</div>
</Banner>
<Banner
	id="welding"
	title={translate("welding")}
	shrink="toBottom"
	textBlockPosition="right"
	image={weldingBannerXl}
	imageSourcesets={{
		"<sm": weldingBannerSm,
		"<md": weldingBannerMd,
		"<lg": weldingBannerLg,
		"<xl": weldingBannerXl,
	}}
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each pointsWelding as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
	</div>
</Banner>
<Banner
	id="heatTreatment"
	title={translate("heatTreatment")}
	image={heatTreatmentBannerXl}
	imageSourcesets={{
		"<sm": heatTreatmentBannerSm,
		"<md": heatTreatmentBannerMd,
		"<lg": heatTreatmentBannerLg,
		"<xl": heatTreatmentBannerXl,
	}}
	shrink="toBottom"
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each heatTreatmentPerex as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
	</div>
</Banner>
<Banner
	id="plastics"
	title={translate("plastics")}
	textBlockPosition="right"
	shrink="toBottom"
	image={plasticsBannerXl}
	imageSourcesets={{
		"<sm": plasticsBannerSm,
		"<md": plasticsBannerMd,
		"<lg": plasticsBannerLg,
		"<xl": plasticsBannerXl,
	}}
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<p class="mb-0 text-base font-light leading-tight min-[425px]:text-[1.125rem] md:mb-[1.125rem]">
			{translate("plasticsPerex1")}
		</p>
		<ul class="ml-5 flex list-disc flex-col text-base font-light min-[425px]:text-[1.125rem]">
			{#each plasticsPerex as point}
				<li>{nbspify(point)}</li>
			{/each}
		</ul>
	</div>
</Banner>
<Banner
	id="production"
	shrink="toBottom"
	title={translate("production")}
	image={productionBannerXl}
	imageSourcesets={{
		"<sm": productionBannerSm,
		"<md": productionBannerMd,
		"<lg": productionBannerLg,
		"<xl": productionBannerXl,
	}}
	wrapperClasses="[&:not(:last-child)]:max-lg:mb-20"
>
	<div slot="content">
		<p class="text-base min-[425px]:text-[1.125rem]">{translate("productionPerex")}</p>
	</div>
</Banner>
